import { all } from 'redux-saga/effects';
import authSagas from 'enl-redux/modules/authSagas';
import managerSagas from 'enl-redux/modules/backoffice/managerSagas';
import logSagas from 'enl-redux/modules/backoffice/logSagas';
import ipSagas from 'enl-redux/modules/backoffice/ipSagas';
import myInfoSagas from 'enl-redux/modules/setting/myInfoSagas';
import perplayUserSagas from 'enl-redux/modules/user/perplayUserSagas';
import gameSagas from 'enl-redux/modules/app/gameSagas';
import campaignSagas from 'enl-redux/modules/app/campaignSagas';
import walletSagas from 'enl-redux/modules/wallet/walletSagas';
import fixAppDataSagas from 'enl-redux/modules/app/fixAppDataSagas';
import partnerSagas from 'enl-redux/modules/backoffice/partnerSagas';
import postSagas from 'enl-redux/modules/user/postSagas';
import maintenanceSagas from 'enl-redux/modules/app/maintenanceSagas';
import itemDBSagas from 'enl-redux/modules/app/itemDBSagas';
import gameSessionLogSagas from 'enl-redux/modules/log/gameSessionLogSagas';
import specialBoxLogSagas from 'enl-redux/modules/log/specialBoxLogSagas';
import notificationSagas from 'enl-redux/modules/notification/notificationSagas';
import loginLogSagas from 'enl-redux/modules/log/loginLogSagas';
import sessionLogSagas from 'enl-redux/modules/log/sessionLogSagas';
// import miningEventSagas from 'enl-redux/modules/event/miningEventSagas';
import freeNFTEventSagas from 'enl-redux/modules/event/freeNFTEventSagas';
import invitationEventSagas from 'enl-redux/modules/event/invitationEventSagas';
import starterPackEventSagas from 'enl-redux//modules/event/starterPackEventSagas';
import systemSagas from 'enl-redux/modules/backoffice/systemSaga';
import powerChargeLogSagas from 'enl-redux/modules/log/powerChargeLogSagas';
import levelUpLogSagas from 'enl-redux/modules/log/levelUpLogSagas';
import breedLogSagas from 'enl-redux/modules/log/breedLogSagas';
import evolveLogSagas from 'enl-redux/modules/log/evolveLogSagas';
import walletTransactionLogSagas from 'enl-redux/modules/log/walletTransactionLogSagas';
import nftTransactionLogSagas from 'enl-redux/modules/log/nftTransactionLogSagas';
import inventoryTransactionLogSagas from 'enl-redux/modules/log/inventoryTransactionLogSagas';
import nftInfoSagas from 'enl-redux/modules/monitoring/nftInfoSagas';
import marketTransactionLogSaga from 'enl-redux/modules/log/marketTransactionLogSagas';
import holderLogSaga from 'enl-redux/modules/log/holderLogSagas';
import nftSagas from 'enl-redux/modules/app/nftSagas';
import drawItemEventSagas from 'enl-redux/modules/event/drawItemEventSagas';
import whiteListAppsSagas from 'enl-redux/modules/app/whiteListAppsSaga';
import appVersionSagas from 'enl-redux/modules/app/appVersionSagas';
import resourceFetchSagas from 'enl-redux/modules/app/resourceFetchSagas';
import gemSocketLogSaga from 'enl-redux/modules/log/gemSocketLogSagas';
import resetStatsLogSaga from 'enl-redux/modules/log/resetStatsLogSagas';
import statisticsSagas from 'enl-redux/modules/monitoring/statisticsSagas';
import nicknameTransactionLogSagas from 'enl-redux/modules/log/nicknameTransactionLogSagas';
import gemSocketUpdateLogSaga from 'enl-redux/modules/log/gemSocketUpdateLogSagas';
import nftRestoreLogSaga from 'enl-redux/modules/log/nftRestoreLogSagas';
import nftRepairLogSaga from 'enl-redux/modules/log/nftRepairLogSagas';
// import nftRentalLogSaga from 'enl-redux/modules/log/nftRentalLogSagas';
import devImageUploadSaga from 'enl-redux/modules/app/devImageUploadSagas';
import depositSagas from 'enl-redux/modules/wallet/depositSagas';
import nftInventoryValidUpdateSagas from 'enl-redux/modules/inventory/nftInventoryValidUpdateSagas';
import walletSettlementSagas from 'enl-redux/modules/wallet/settlementSagas';
import gearMiningLogSaga from 'enl-redux/modules/log/gearMiningLogSagas';
import nftDisassembleLogSaga from 'enl-redux/modules/log/nftDisassembleLogSagas';
import userItemManageSagas from 'enl-redux/modules/app/userItemManageSagas';
// import inAppIconsSaga from 'enl-redux/modules/app/inAppIconsSagas';
import eventPartnerSagas from 'enl-redux/modules/event/eventPartnerSagas';
import missionSagas from 'enl-redux/modules/app/basicSagas';
import basicMissionLogSaga from 'enl-redux/modules/log/basicMissionLogSagas';
import walletConnectionLogSaga from 'enl-redux/modules/log/walletConnectionLogSagas';
import transactionAttemptLogSaga from 'enl-redux/modules/log/transactionAttemptLogSagas';
import inAppRankSystemSaga from 'enl-redux/modules/app/inAppRankSystemSagas';
import storedPowerLogSaga from 'enl-redux/modules/log/storedPowerLogSagas';
import bannerSagas from 'enl-redux/modules/event/bannerSagas';
import itemBoxLogSagas from 'enl-redux/modules/log/itemBoxLogSagas';
import raffleSagas from 'enl-redux/modules/event/raffleSagas';
import safetyCodeLogSagas from 'enl-redux/modules/log/safetyCodeLogSagas';
import itemShopSagas from 'enl-redux/modules/app/itemShopSagas';
import googleStoreSagas from 'enl-redux/modules/app/googleStoreSagas';
import itemShopLogSagas from 'enl-redux/modules/log/itemShopLogSagas';
import googleStorePurchaseLogSagas from 'enl-redux/modules/log/googleStorePurchaseLogSagas';
import fileUploadSagas from 'enl-redux/modules/app/fileUploadSagas';
import noticeSagas from 'enl-redux/modules/event/noticeSagas'
import pilotLogSagas from "enl-redux/modules/log/pilotLogSagas";

export default function* sagas() {
  yield all([
    ...authSagas,
    ...managerSagas,
    ...walletSagas,
    ...walletSettlementSagas,
    ...logSagas,
    ...ipSagas,
    ...myInfoSagas,
    ...campaignSagas,
    ...perplayUserSagas,
    ...gameSagas,
    ...fixAppDataSagas,
    ...partnerSagas,
    ...postSagas,
    ...maintenanceSagas,
    ...itemDBSagas,
    ...gameSessionLogSagas,
    ...specialBoxLogSagas,
    ...notificationSagas,
    ...loginLogSagas,
    ...sessionLogSagas,
    // ...miningEventSagas,
    ...freeNFTEventSagas,
    ...invitationEventSagas,
    ...starterPackEventSagas,
    ...systemSagas,
    ...powerChargeLogSagas,
    ...levelUpLogSagas,
    ...breedLogSagas,
    ...evolveLogSagas,
    ...walletTransactionLogSagas,
    ...nftTransactionLogSagas,
    ...inventoryTransactionLogSagas,
    ...nftInfoSagas,
    ...statisticsSagas,
    ...marketTransactionLogSaga,
    ...holderLogSaga,
    ...gemSocketLogSaga,
    ...resetStatsLogSaga,
    ...nicknameTransactionLogSagas,
    ...gemSocketUpdateLogSaga,
    ...nftRestoreLogSaga,
    ...nftRepairLogSaga,
    // ...nftRentalLogSaga,
    ...nftSagas,
    ...drawItemEventSagas,
    ...whiteListAppsSagas,
    ...appVersionSagas,
    ...resourceFetchSagas,
    ...devImageUploadSaga,
    // ...inAppIconsSaga,
    ...depositSagas,
    ...nftInventoryValidUpdateSagas,
    ...gearMiningLogSaga,
    ...nftDisassembleLogSaga,
    ...userItemManageSagas,
    ...eventPartnerSagas,
    ...missionSagas,
    ...basicMissionLogSaga,
    ...walletConnectionLogSaga,
    ...inAppRankSystemSaga,
    ...storedPowerLogSaga,
    ...transactionAttemptLogSaga,
    ...bannerSagas,
    ...itemBoxLogSagas,
    ...raffleSagas,
    ...safetyCodeLogSagas,
    ...itemShopSagas,
    ...googleStoreSagas,
    ...itemShopLogSagas,
    ...googleStorePurchaseLogSagas,
    ...fileUploadSagas,
    ...noticeSagas,
    ...pilotLogSagas
  ]);
}
